module.exports = __webpack_public_path__ + "static/media/choithramsLayerThree.bb8ce486.png";